export default "__VITE_ASSET__2ffd2c26__"